/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../routes/__root'
import { Route as appRouteRouteImport } from './../routes/(app)/route'
import { Route as appIndexRouteImport } from './../routes/(app)/index'
import { Route as authLoginRouteImport } from './../routes/(auth)/login'
import { Route as OauthCallbackRouteImport } from './../routes/oauth/callback'
import { Route as appAiListingStudioRouteImport } from './../routes/(app)/ai/listing-studio'
import { Route as appOrdersIndexRouteImport } from './../routes/(app)/orders/index'
import { Route as appProductsIndexRouteImport } from './../routes/(app)/products/index'
import { Route as appSettingsIndexRouteImport } from './../routes/(app)/settings/index'
import { Route as appShopsIndexRouteImport } from './../routes/(app)/shops/index'
import { Route as appShopsNewRouteImport } from './../routes/(app)/shops/new'

const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const appIndexRoute = appIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthCallbackRoute = OauthCallbackRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const appAiListingStudioRoute = appAiListingStudioRouteImport.update({
  id: '/ai/listing-studio',
  path: '/ai/listing-studio',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrdersIndexRoute = appOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => appRouteRoute,
} as any)
const appProductsIndexRoute = appProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => appRouteRoute,
} as any)
const appSettingsIndexRoute = appSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => appRouteRoute,
} as any)
const appShopsIndexRoute = appShopsIndexRouteImport.update({
  id: '/shops/',
  path: '/shops/',
  getParentRoute: () => appRouteRoute,
} as any)
const appShopsNewRoute = appShopsNewRouteImport.update({
  id: '/shops/new',
  path: '/shops/new',
  getParentRoute: () => appRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/login': typeof authLoginRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/': typeof appIndexRoute
  '/ai/listing-studio': typeof appAiListingStudioRoute
  '/shops/new': typeof appShopsNewRoute
  '/orders/': typeof appOrdersIndexRoute
  '/products/': typeof appProductsIndexRoute
  '/settings/': typeof appSettingsIndexRoute
  '/shops/': typeof appShopsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof authLoginRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/': typeof appIndexRoute
  '/ai/listing-studio': typeof appAiListingStudioRoute
  '/shops/new': typeof appShopsNewRoute
  '/orders': typeof appOrdersIndexRoute
  '/products': typeof appProductsIndexRoute
  '/settings': typeof appSettingsIndexRoute
  '/shops': typeof appShopsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/oauth/callback': typeof OauthCallbackRoute
  '/(app)/': typeof appIndexRoute
  '/(app)/ai/listing-studio': typeof appAiListingStudioRoute
  '/(app)/shops/new': typeof appShopsNewRoute
  '/(app)/orders/': typeof appOrdersIndexRoute
  '/(app)/products/': typeof appProductsIndexRoute
  '/(app)/settings/': typeof appSettingsIndexRoute
  '/(app)/shops/': typeof appShopsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/oauth/callback'
    | '/'
    | '/ai/listing-studio'
    | '/shops/new'
    | '/orders/'
    | '/products/'
    | '/settings/'
    | '/shops/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/oauth/callback'
    | '/'
    | '/ai/listing-studio'
    | '/shops/new'
    | '/orders'
    | '/products'
    | '/settings'
    | '/shops'
  id:
    | '__root__'
    | '/(app)'
    | '/(auth)/login'
    | '/oauth/callback'
    | '/(app)/'
    | '/(app)/ai/listing-studio'
    | '/(app)/shops/new'
    | '/(app)/orders/'
    | '/(app)/products/'
    | '/(app)/settings/'
    | '/(app)/shops/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  authLoginRoute: typeof authLoginRoute
  OauthCallbackRoute: typeof OauthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/': {
      id: '/(app)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/ai/listing-studio': {
      id: '/(app)/ai/listing-studio'
      path: '/ai/listing-studio'
      fullPath: '/ai/listing-studio'
      preLoaderRoute: typeof appAiListingStudioRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/orders/': {
      id: '/(app)/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof appOrdersIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/products/': {
      id: '/(app)/products/'
      path: '/products'
      fullPath: '/products/'
      preLoaderRoute: typeof appProductsIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/settings/': {
      id: '/(app)/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof appSettingsIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/shops/': {
      id: '/(app)/shops/'
      path: '/shops'
      fullPath: '/shops/'
      preLoaderRoute: typeof appShopsIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/shops/new': {
      id: '/(app)/shops/new'
      path: '/shops/new'
      fullPath: '/shops/new'
      preLoaderRoute: typeof appShopsNewRouteImport
      parentRoute: typeof appRouteRoute
    }
  }
}

interface appRouteRouteChildren {
  appIndexRoute: typeof appIndexRoute
  appAiListingStudioRoute: typeof appAiListingStudioRoute
  appShopsNewRoute: typeof appShopsNewRoute
  appOrdersIndexRoute: typeof appOrdersIndexRoute
  appProductsIndexRoute: typeof appProductsIndexRoute
  appSettingsIndexRoute: typeof appSettingsIndexRoute
  appShopsIndexRoute: typeof appShopsIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appIndexRoute: appIndexRoute,
  appAiListingStudioRoute: appAiListingStudioRoute,
  appShopsNewRoute: appShopsNewRoute,
  appOrdersIndexRoute: appOrdersIndexRoute,
  appProductsIndexRoute: appProductsIndexRoute,
  appSettingsIndexRoute: appSettingsIndexRoute,
  appShopsIndexRoute: appShopsIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  authLoginRoute: authLoginRoute,
  OauthCallbackRoute: OauthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
